import Axios from 'axios';
import { tsvParse as d3TsvParse } from 'd3-dsv';
import AsyncMap from 'async/map';

const LOAD_START = 'ImportExportVis/VisState/LOAD_START';
const LOAD_SUCCESS = 'ImportExportVis/VisState/LOAD_SUCCESS';
const LOAD_ERROR = 'ImportExportVis/VisState/LOAD_ERROR';

const SVG_LOAD_START = 'ImportExportVis/VisState/SVG_LOAD_START';
const SVG_LOAD_SUCCESS = 'ImportExportVis/VisState/SVG_LOAD_SUCCESS';
const SVG_LOAD_ERROR = 'ImportExportVis/VisState/SVG_LOAD_ERROR';

const SET_YEAR = 'ImportExportVis/VisState/SET_YEAR';

const START_YEAR = 2006;
const END_YEAR = 2015;
// const ANIMATION_SPEED = 1000;

const initialState = {
  importData: false,
  exportData: false,
  dataLoaded: false,
  svgDataLoaded: false,
  currentYear: START_YEAR,
  exportSVG: false,
  importSVG: false,


};

export function loadData() {
  return (dispatch, getState) => {
    dispatch({ type: LOAD_START });

    AsyncMap(['data/import.csv', 'data/export.csv'], (filename, callback) => {
      Axios.get(filename)
        .then(res => callback(null, d3TsvParse(res.data)))
        .catch(err => { console.log(err) });
    }, (err, results) => {
      if(err) {
        return dispatch({ type: LOAD_ERROR });
      }

      dispatch({ type: LOAD_SUCCESS, payload: {
        importData: cleanData(results[0]),
        exportData: cleanData(results[1])}
      });

      // return setTimeout(() => animate(dispatch, getState), ANIMATION_SPEED);
    });
  }
}


export function loadSVG() {
  return (dispatch, getState) => {
    dispatch({ type: SVG_LOAD_START });

    const dataPath = "data/import-export/"

    let importSVG = {};
    let exportSVG = {};

    let files = [];
    for(let i=2006; i<=2015; i++){
      files.push(`${dataPath}import-${i}.svg`);
      files.push(`${dataPath}export-${i}.svg`);
    }


    AsyncMap(files, (filename, callback) => {

      Axios.get(filename)
        .then(res => callback(null, res.data))
        .catch(err => { console.log(err) });
    }, (err, results) => {

      if(err) {
        return dispatch({ type: SVG_LOAD_ERROR });
      }

      for(let i=0; i<10; i++){
        importSVG[`import${2006+i}`] = results[i*2];
      }

      for(let i=0; i<10; i++){
        exportSVG[`export${2006+i}`] = results[(i*2)+1];
      }


      dispatch({ type: SVG_LOAD_SUCCESS, payload: {
          import: importSVG,
          export: exportSVG
        }
      });

      // return setTimeout(() => animate(dispatch, getState), ANIMATION_SPEED);
    });
  }
}

export function incrementYear() {
  return (dispatch, getState) => {
    const state = getState().ImportExportVisState;
    const nextYear = state.currentYear >= END_YEAR ? START_YEAR : state.currentYear + 1;
    dispatch({ type: SET_YEAR, payload: nextYear });
  }
}

export function decrementYear() {
  return (dispatch, getState) => {
    const state = getState().ImportExportVisState;
    const nextYear = state.currentYear <= START_YEAR ? END_YEAR : state.currentYear - 1;
    dispatch({ type: SET_YEAR, payload: nextYear });
  }
}

// function animate(dispatch, getState) {
//   const state = getState().ImportExportVisState;
//   const nextYear = state.currentYear >= END_YEAR ? START_YEAR : state.currentYear + 1;

//   dispatch({ type: SET_YEAR, payload: nextYear });
//   setTimeout(() => animate(dispatch, getState), ANIMATION_SPEED);
// }

function cleanData(data) {
  return data.map(d => {
    for(var y = START_YEAR; y <= END_YEAR; y++) {
      d[y] = parseValue(d[y]);
    }
    return d;
  });
}

function parseValue(val) {
  val = val.replace('.', '').replace(',', '.');
  return isNaN(parseFloat(val)) ? null : parseFloat(val);
}

export default function AppReducer(state = initialState, action = {}) {
  switch(action.type) {
    case LOAD_SUCCESS:
     return Object.assign({}, state, {
       ...action.payload,
       dataLoaded: true
     });

    case SVG_LOAD_SUCCESS:
     return Object.assign({}, state, {
        ...action.payload,
        svgDataLoaded: true
      });

    case SET_YEAR:
      return Object.assign({}, state, { currentYear: action.payload });

    default:
      return Object.assign({}, state)
  }
};



// WEBPACK FOOTER //
// ./src/modules/ImportExportVis/VisState.js